import React from "react";
import styled from "@emotion/styled";
import { motion } from "motion/react";
import { useMDSSession } from "@/mds/components/sessions/session-context";
import { usePreviewSessionItems } from "@/mds/components/sessions/session-item";
import { SessionItemRenderer } from "@/mds/components/sessions/session-item/session-item-renderer";
import { useSessionRenderContext } from "../../session-list/session-list.utils";

type Props = {};

export const MDSSessionPreviewView: React.FC<Props> = () => {
  const { finalizedSessionItems, sessionStatus, sessionConfig, sessionViewMode } = useMDSSession();

  const { previewSessionItems } = usePreviewSessionItems({ sessionItems: finalizedSessionItems });

  const context = useSessionRenderContext({
    sessionStatus,
    sessionViewMode,
    sessionItems: finalizedSessionItems,
    sessionConfig,
  });

  return (
    <ExpandedContent>
      <motion.div
        key="content"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.2, delay: 0.2, ease: [0.4, 0, 0.2, 1] }}
      >
        <Content>
          {previewSessionItems.map(item => (
            <SessionItemRenderer key={item.id} data={item} context={context} />
          ))}
        </Content>
      </motion.div>
    </ExpandedContent>
  );
};

const ExpandedContent = styled.div`
  width: 100%;
  min-height: 220px;
`;

const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 ${({ theme }) => theme.spacing["6"]} ${({ theme }) => theme.spacing["6"]};
`;
